export const createPhotoSlideshow = ({
    button,
    progress,
    onAdvance,
    intervalMilliseconds = 5000,
}) => {
    let timeoutId = null;

    let playing = false;

    const reducedMotionQuery =
        window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        );

    const playIcon =
        button?.querySelector(
            '[data-photo-slideshow-play-icon]'
        );

    const pauseIcon =
        button?.querySelector(
            '[data-photo-slideshow-pause-icon]'
        );

    const clearTimer = () => {
        if (timeoutId === null) {
            return;
        }

        window.clearTimeout(
            timeoutId
        );

        timeoutId = null;
    };

    const resetProgress = () => {
        if (!progress) {
            return;
        }

        progress.style.transition = 'none';

        progress.style.transform =
            'scaleX(0)';

        progress
            .getBoundingClientRect();

        progress.classList.add(
            'opacity-0'
        );
    };

    const startProgress = () => {
    if (!progress) {
        return;
    }

    progress.style.transition =
        'none';

    progress.style.transform =
        'scaleX(0)';

    progress.classList.remove(
        'opacity-0'
    );

    if (
        reducedMotionQuery.matches
    ) {
        progress.style.transform =
            'scaleX(1)';

        return;
    }

    requestAnimationFrame(
        () => {
            requestAnimationFrame(
                () => {
                    if (!playing) {
                        return;
                    }

                    progress.style.transition =
                        `transform ${intervalMilliseconds}ms linear`;

                    progress.style.transform =
                        'scaleX(1)';
                }
            );
        }
    );
};

    const render = () => {
        if (!button) {
            return;
        }

        button.setAttribute(
            'aria-pressed',
            playing
                ? 'true'
                : 'false'
        );

        button.setAttribute(
            'aria-label',
            playing
                ? 'Pause slideshow'
                : 'Play slideshow'
        );

        button.title =
            playing
                ? 'Pause slideshow'
                : 'Play slideshow';

        playIcon?.classList.toggle(
            'hidden',
            playing
        );

        pauseIcon?.classList.toggle(
            'hidden',
            !playing
        );

        button.classList.toggle(
            'bg-cyan-300',
            playing
        );

        button.classList.toggle(
            'text-slate-950',
            playing
        );

        button.classList.toggle(
            'bg-slate-950/80',
            !playing
        );

        button.classList.toggle(
            'text-white',
            !playing
        );
    };

    const scheduleNextPhoto = () => {
        clearTimer();

        if (!playing) {
            resetProgress();

            return;
        }

        startProgress();

        timeoutId =
    window.setTimeout(
        () => {
            timeoutId = null;

            onAdvance();
        },
        intervalMilliseconds
    );
    };

    const play = () => {
        if (
            playing
            || !button
            || button.disabled
        ) {
            return;
        }

        playing = true;

        render();

        scheduleNextPhoto();
    };

    const pause = () => {
        playing = false;

        clearTimer();

        resetProgress();

        render();
    };

    const toggle = () => {
        if (playing) {
            pause();

            return;
        }

        play();
    };

    const restart = () => {
        if (!playing) {
            return;
        }

        scheduleNextPhoto();
    };

    const setAvailable = (
        available
    ) => {
        if (!button) {
            return;
        }

        button.disabled =
            !available;

        button.classList.toggle(
            'hidden',
            !available
        );

        if (!available) {
            pause();
        }
    };

    const handleReducedMotionChange =
        () => {
            if (!playing) {
                return;
            }

            scheduleNextPhoto();
        };

    reducedMotionQuery.addEventListener?.(
        'change',
        handleReducedMotionChange
    );

    button?.addEventListener(
        'click',
        toggle
    );

    resetProgress();

    render();

    return {
        isPlaying: () => playing,

        pause,

        play,

        restart,

        setAvailable,

        stop: pause,

        toggle,
    };
};